module.exports = __webpack_public_path__ + "img/success.cce72f3c.svg";